<template>

    <!-- IF COLLAPSE -->
    <el-collapse v-model="activeField" class="flex-column mb-9" v-if="toggleAllowed" :id="`form-field-${field}`">
        <el-collapse-item :name="field" active>
            <template slot="title">
                    <icon-svg :icon-name="field" :width="24" :height="24" viewBox="0 0 32 32">
                        <component :is="('icon-' + field)"></component>
                    </icon-svg>
                <strong class="ml-3 fs-4 self-center lh-20 ">{{ title }}</strong>
            </template>

            <div class="px-6">
                <slot />
            </div>
        </el-collapse-item>
    </el-collapse >

    <!-- IF DOESNT COLLAPS -->
    <div class="flex-column mb-9" :id="`form-field-${field}`" v-else>
        <div class="lh-24 flex-row bb-1-gray-05 pb-2 ai-center">
            <icon-svg :icon-name="field" :width="24" :height="24" viewBox="0 0 32 32">
                <component :is="('icon-' + field)"></component>
            </icon-svg>
            <div class="flex-row jc-space wp-10 ml-3">
                <strong class="fs-4 self-center">{{ title }}</strong>
                <h6 v-if="switchAllowed" class="cpointer semibold form-fields-wrapper--switch link fs-3 lh-20 m-0" @click="$emit('switch-form-field')" :data-bot="`opp-overview__company--link-switch-${field}`">{{ switchLabel }}</h6>
            </div>
        </div>
        <div class="px-6">
            <slot />
        </div>
    </div >

</template>

<script>
    import IconSvg from 'vcomponents/icons/IconSvg.vue';
    import IconCompany from 'vcomponents/icons/IconCompany.vue';
    import IconLegalAndBilling from 'vcomponents/icons/IconLegalAndBilling.vue';
    import IconAddress from 'vcomponents/icons/IconAddress.vue';
    import IconContact from 'vcomponents/icons/IconContact.vue';
    import IconAccounting from 'vcomponents/icons/IconAccounting.vue';
    import IconCustomFields from 'vcomponents/icons/IconCustomFields.vue';
    import IconIndividual from 'vcomponents/icons/IconIndividualActivity.vue';
    import IconOpportunity from 'vcomponents/icons/IconOpportunity.vue';

export default{
        props: {
            activeFields:{
                type: Array,
                required: false,
            },
            title: {
                type: String,
                required: true
            },
            toggleAllowed: {
                type: Boolean,
                required: false,
                default: false
            },
            field: {
                type: String,
                required: true
            },
            switchAllowed: {
                type: Boolean,
                required: false,
                default: false
            }  
        },
        data(){
            return{
                activeField : this.activeFields,
            }
        },
        components:{
            IconSvg,
            IconCompany,
            IconLegalAndBilling,
            IconAddress,
            IconContact,
            IconCustomFields,
            IconAccounting,
            IconOpportunity,
            IconIndividual,
        },
        computed:{
            switchLabel(){
                return (this.field !== "company" ? this.$l10n.__("Il s’agit d’une société ?") : this.$l10n.__("Il s’agit d’un particulier?"));
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form-fields-wrapper--switch{
        place-self: self-end;
    }
    .flex-column svg{
        min-width: 24px;
    }
</style>
<style lang="scss">
    .el-collapse-item__header.is-active, .el-collapse-item__header{
        padding-bottom: 8px;
    }
</style>